import styled from 'styled-components';

export default styled.h5`
  font-weight: 600;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.175em;
  text-transform: uppercase;
  color: var(--orange-100);
`;